<footer class="app-footer">
    <div class="footer-content">
        {{ labels.getFooterText(currentYear, companyName) }}
        <span>|</span>
        <a [href]="privacyUrl" target="_blank">{{ labels.privacyPolicy }}</a>
        {{ labels.and}}
        <a [href]="termsUrl" target="_blank">{{ labels.termsOfUse }}</a>
    </div>
</footer>